import { Eyebrow, Reveal } from "./motion";
import { TURNING_POINT } from "../config/content";

export default function TurningPoint() {
  return (
    <section className="py-16 md:py-24" data-testid="turning-point-section">
      <div className="max-w-[1180px] mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="relative rounded-3xl bg-[#0F1712] border border-[#22C55E]/40 px-6 py-12 sm:px-12 sm:py-16 text-center overflow-hidden shadow-[0_0_80px_-20px_rgba(34,197,94,0.4)]">
            <div className="absolute -top-24 left-1/2 -translate-x-1/2 w-[500px] h-[300px] bg-[#22C55E]/15 blur-[100px] rounded-full pointer-events-none" aria-hidden="true" />
            <div className="relative">
              <Eyebrow center>{TURNING_POINT.eyebrow}</Eyebrow>
              <h2 className="font-heading uppercase text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-wide" data-testid="turning-point-heading">
                {TURNING_POINT.titleA}{" "}
                <span className="text-[#22C55E]">{TURNING_POINT.titleHighlight}</span>
              </h2>
              <p className="mt-6 text-base sm:text-lg text-[#A7B3AA] leading-relaxed max-w-3xl mx-auto" data-testid="turning-point-text">
                {TURNING_POINT.text}
              </p>
              <p className="mt-10 font-heading uppercase text-3xl sm:text-4xl text-white tracking-wide" data-testid="turning-point-big-line">
                We don't sell <span className="text-[#EF4444]">tips</span>. We build <span className="text-[#22C55E]">traders</span>.
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
